import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toastText } from 'utils/utils';
import { directDepositApi } from '../../../Api/directDeposit';
import PaymentInfoDetails from './Table';


const PaymentDetails = () => {

	const [paymentData, setPaymentData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecords, setTotalRecords] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [searchParams] = useSearchParams();

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const fetchPayment = async () => {
		try {
			const employeeId = searchParams.get('employeeId');
			setIsLoading(true);
			const query = {
				employeeId: employeeId,
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};
     
      const salaries = await directDepositApi.getPaymentHistory(query)
		setPaymentData(salaries.data.data);
			setTotalRecords(salaries.data.count);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching salaries';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (searchParams.get('employeeId')) {
			fetchPayment();
		}
	}, [pageSize, currentPage, sortOrder, sortField]);




	return (
		<div>
			{/* <div className={styles['employee-salary-container']}> */}
      <div>
				<PaymentInfoDetails
					paymentInfoData={paymentData}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
					tableChangeHandler={tableChangeHandler}
					isLoading={isLoading}
				/>
			</div>
		</div>
	);
};

export default PaymentDetails;
